module.exports = __webpack_public_path__ + "static/img/1600958630547008160.1e7138f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/jiameng/1600958630547008160.jpg
// module id = zoIO
// module chunks = 0